import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { Cont } from './styled'

const ReceiveInformationComponent = (props) => {

  const { 
    valueForm,
    // props
  } = props

  const getFileBGC03 = () =>{
    return valueForm.attachments.filter(x=>x.documentCode=='BGC03')
  }

  return (
    <StdCard title={<span className='stepTitle'>Receive Information</span>}>
      <Cont>
        <RowFields>
          {(valueForm.status==202&&valueForm.sn)||valueForm.appointmentReceiveDate?
          <Field 
            name="appointmentReceiveDate"
            label="Appointment for Receive Date"
            component={FieldInput}
            type={type.date}
            className='halfRow'
            editable={valueForm.status==202&&valueForm.sn}
            require
          />:null}
          {(valueForm.status==203&&valueForm.sn)||valueForm.receiveDate?
          <Field 
            name="receiveDate"
            label="Receive Date"
            component={FieldInput}
            type={type.date}
            className='halfRow'
            editable={valueForm.status==203&&valueForm.sn}
            require
          />:null}
        </RowFields>
        {(valueForm.status==202&&valueForm.sn)||valueForm.appointmentReceiveDate?
        <RowFields style={{justifyContent:'start'}}>
          <Field 
            name='bgc03'
            label='Bank Guarantee'
            type={type.file}
            editable={(valueForm.status==202&&valueForm.sn)}
            component={FieldInput} 
            oldFiles={getFileBGC03()}
            showOldFile={true}
            multipleSelect={false}
            limitFileItem={1}
            require
            acceptFileType='.pdf'/>
        </RowFields>:null}
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompanyRequest')(state) || {},
  }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveInformationComponent)
